import {
    PERMISSIONS_OPERATORS,
    BACKSTAGE_CONTENT_PERMISSION,
} from '../../modules/taboola-common-frontend-modules/authentication';
import { hrefFactoryForLegacyModules } from '../backstage-content';

const MODULE_NAME = 'user-management';
const externalPath = 'reports/admin/user-management';
const hrefGetter = hrefFactoryForLegacyModules(MODULE_NAME, externalPath);
const modulePermissions = {
    permissions: ['LIGHT_USER_EDIT', 'USER_EDIT'],
    operator: PERMISSIONS_OPERATORS.OR,
};
const permissions = {
    permissions: [BACKSTAGE_CONTENT_PERMISSION, modulePermissions],
    operator: PERMISSIONS_OPERATORS.AND,
};

export { MODULE_NAME, hrefGetter, permissions, externalPath };
